// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import iView from 'iview';
import translate from '@/commen/translate.config'
import VueI18n from 'vue-i18n'

import toPosition from './plugin/toPosition'
import vueUtil from './plugin/vueUtil'
import lang from '@/lang.json'
import 'iview/dist/styles/iview.css'; // 使用 CSS
require('font-awesome-webpack');
require('../static/js/tween');
import  global_ from  './common/global'
import { emoji } from './common/emoji.js'
import vueLazyload from 'vue-lazyload'
import vueTouchRipple from 'vue-touch-ripple'
import 'vue-touch-ripple/component.css'
import loadingImage from '../static/imgs/loading.gif'
//数据统计
import statistics from './common/statistics.js'
import 'babel-polyfill'
Vue.prototype.getStatistic=statistics


// 加载字体
import '@common/font/iconfont.css'

Vue.config.productionTip = false;
Vue.use(iView);
Vue.use(vueTouchRipple);
Vue.use(VueI18n)

Vue.use(vueLazyload, {
  preLoad: 1.3,
  error: loadingImage,
  loading: loadingImage,
  attempt: 1
});

Vue.use(toPosition);
Vue.use(vueUtil);

router.beforeEach((to, from, next) => {
  let lang = localStorage.getItem('locale')
  if(lang === null){
    lang = window.navigator.language;
    if (lang != 'zh-CN') {
      lang = "en";
    } else {
      lang = 'ch';
    }
    localStorage.setItem('locale', lang);
  }

  localStorage.setItem('homePath', window.location.href);
    //模板默认是中文的

  const name = to.name;
  const reg = /tpl[0-9][hH]ome/;
  if (reg.test(name)) {
    //  如果访问的是主页内容
    let oldCid = localStorage.getItem('cid');
    let newCid = to.params.cid;
    if (oldCid != newCid) {
      //  如果两个cid不一样，说明访问的是不同的会议,清除本地缓存
      // localStorage.clear();
      // sessionStorage.clear();
    }
  }
  window.scrollTo(0, 0);
  next();
});
Vue.prototype.emoji = emoji;
Vue.prototype.GLOBAL = global_;
String.prototype.trim=function(){return this.replace(/(^\s+)|(\s+$)/g,'')}
/*时间格式化 公用方法*/
Date.prototype.Format = function (fmt) { //
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}
Vue.prototype.getDiffDays = function (startDate, endDate) {
  if (startDate == '' || endDate == '') {
    return "0";
  } else {
    var startTime = new Date(Date.parse(startDate.replace(/-/g, "/"))).getTime();
    var endTime = new Date(Date.parse(endDate.replace(/-/g, "/"))).getTime();
    var dates = Math.abs((startTime - endTime)) / (1000 * 60 * 60 * 24);
    if (isNaN(dates)) {
      dates = "0";
    }
    return dates;
  }
}
Vue.prototype.validateMobile = function (phone) {
  var myreg = /^1[34578]\d{9}$/;
  if (!myreg.test(phone)) {
    return false;
  }
  return true;
}
// 在实例已创建后修改默认值
var instance = axios.create();

// 在实例已创建后修改默认值
Vue.prototype.postHttp = function (url, param) {
  //如果有token；就加上token到请求对象的header上
  if (localStorage.getItem("user") != null && JSON.parse(localStorage.getItem("user")).token) {
    instance.defaults.headers.common['token'] = JSON.parse(localStorage.getItem("user")).token;
  } else {
    instance.defaults.headers.common['token'] = localStorage.getItem("token");
  }
  instance.defaults.headers.common['language'] = (localStorage.getItem("locale") == "en" ? "en" : "");
  return instance.post(url, param);
};


let locale = localStorage.getItem('locale')
if (locale === null) {
  locale = window.navigator.language||window.navigator.browserLanguage;
  if (locale != 'zh-CN') {
    locale = "en";
  } else {
    locale = 'ch';
  }
  localStorage.setItem('locale', locale);
}

const i18n = new VueI18n({
  locale: locale, // set locale
  messages: translate // set locale messages
})
 function GetQueryString (name){
     var after = window.location.hash.split("?")[1];
    if(after)
    {
        var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
        var r = after.match(reg);
         if(r != null)
         {
            return  decodeURIComponent(r[2]);
         }
        else
        {
            return null;
         }
     }
 }
 if(GetQueryString('sourceid')){
   localStorage.setItem('sourceId',GetQueryString('sourceid'))
 }else{
  localStorage.setItem('sourceId','')
 }

new Vue({
  el: '#app',
  router,
  i18n,
  template: '<App/>',
  methods:{
    changeLanguage(val){
      this.$i18n.local = val
    }
  },
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js